<template>
  <div class="bj"></div>
</template>
<script>
import { req_userInfo,req_userLogin } from "@/services/user";

export default {
  name: "bj",
  components: {},
  data() {
    return {};
  },
  methods: {
    async func_bj(params) {
      let result = await req_userLogin(
          params.userid,
          params.password
        );
      if (result.success) {
        // this.$parent.msgChange("success", "登录成功", "", 3000);
        // 1) 清除该清除的
        this.STORAGE.remove("g_userInfo");
        this.STORAGE.remove("g_trollerList");
        // 2) 调用全局登录流程
        result.data.head = true
        this.$parent.func_appLoginwithworker(result.data);
        if (this.$route.path !== '/order') {
          this.$router.push({
                    name: "order",
                    query:true,
                  })
        }
        this.$parent.func_webTab_offerClass(params.f)
      } else {
        this.$parent.msgChange("fail", result.msg, "", 3000);
      }
    },
  },
  mounted() {
    const params = this.$route.params;
      this.func_bj(params);
  },
  destroyed() {},
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/bj.vue